/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * One managed tool's outcome from the agent's last reconcile. Carries no error text or user-facing message: those can name paths and entries the agent does not own.
 */
export type AgentStateTool = {
  /**
   * True when a problem the user can fix is blocking this tool.
   */
  actionRequired?: boolean | undefined;
  /**
   * Times since drift_counting_since the agent rewrote what it owns in this tool although the applied policy had not changed. Omitted when this tool's syncer does not measure drift.
   */
  driftCorrections?: number | undefined;
  /**
   * Class of a reconcile error: permission_denied, not_found, invalid_config, or unknown.
   */
  errorKind?: string | undefined;
  /**
   * Resolved enforcement layer: user, managed, or off.
   */
  layer: string;
  /**
   * Reconcile outcome: armed, pending, skipped (tool not installed), error, or unmanaged.
   */
  outcome: string;
  /**
   * Why a pending tool is not yet enforcing: privileged_writer_not_ready or plugin_bundle_not_cloned.
   */
  pendingReason?: string | undefined;
  /**
   * True when the agent wrote configuration the tool loads only after it restarts.
   */
  restartRequired?: boolean | undefined;
  /**
   * Stable tool id, e.g. claude_code.
   */
  tool: string;
};

/** @internal */
export type AgentStateTool$Outbound = {
  action_required?: boolean | undefined;
  drift_corrections?: number | undefined;
  error_kind?: string | undefined;
  layer: string;
  outcome: string;
  pending_reason?: string | undefined;
  restart_required?: boolean | undefined;
  tool: string;
};

/** @internal */
export const AgentStateTool$outboundSchema: z.ZodMiniType<
  AgentStateTool$Outbound,
  AgentStateTool
> = z.pipe(
  z.object({
    actionRequired: z.optional(z.boolean()),
    driftCorrections: z.optional(z.int()),
    errorKind: z.optional(z.string()),
    layer: z.string(),
    outcome: z.string(),
    pendingReason: z.optional(z.string()),
    restartRequired: z.optional(z.boolean()),
    tool: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      actionRequired: "action_required",
      driftCorrections: "drift_corrections",
      errorKind: "error_kind",
      pendingReason: "pending_reason",
      restartRequired: "restart_required",
    });
  }),
);

export function agentStateToolToJSON(agentStateTool: AgentStateTool): string {
  return JSON.stringify(AgentStateTool$outboundSchema.parse(agentStateTool));
}
